import {i18nKey} from '@/locales/i18n';
import IconDuplicate from '@/assets/icons/ic_duplicate.svg';
import IconDelete from '@/assets/icons/ic_delete.svg';
import IconEdit from '@/assets/icons/ic_edit_gray.svg';
import IconShare from '@/assets/icons/ic_share.svg';

export enum MENU_KEY_WORKFLOW {
  edit = '1',
  duplicate = '2',
  delete = '3',
  shareWithAdmin = '4',
}

export const ITEM_ACTION_WORKFLOW = [
  {
    key: '1',
    label: () => i18nKey.workFlowScreen.workFlows.action.edit,
    icon: IconEdit,
  },
  {
    key: '4',
    label: () => i18nKey.workFlowScreen.workFlows.action.shareWithAdmin,
    icon: IconShare,
  },
  {
    key: '2',
    label: () => i18nKey.workFlowScreen.workFlows.action.duplicate,
    icon: IconDuplicate,
  },
  {
    key: '3',
    label: () => i18nKey.workFlowScreen.workFlows.action.delete,
    icon: IconDelete,
  },
];

export enum PERMISSION {
  export_workflow = 'Export Workflows',
  export_template = 'Export Templates',
  export_metadata = 'Export Metadata tables',
  mbal = 'MBAL',
  workflows = 'Workflows',
}
